import { addToRecord } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { GenerateCuratedThreadsFulfilledAction } from '../../domains/curatedThreadList/actions.types';

import { CuratedThreadListIdMap } from './types';

const initialState: CuratedThreadListIdMap = {};

const reducer: Reducer<CuratedThreadListIdMap, GenerateCuratedThreadsFulfilledAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'GENERATE_CURATED_THREADS.FULFILLED': {
      const { fileId, curatedThreadListId } = action.payload;

      return addToRecord(state, fileId, {
        id: fileId,
        curatedThreadListId,
      });
    }
    default:
      return state;
  }
};

export default reducer;
